var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOwnershipRights(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 3,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.296 16.424l-1.752-3.18h-.492v3.18H9V8h3.444c.664 0 1.228.116 1.692.348.472.232.824.552 1.056.96.232.4.348.848.348 1.344 0 .56-.16 1.06-.48 1.5-.312.44-.776.752-1.392.936l1.944 3.336h-2.316zm-2.244-4.632h1.272c.376 0 .656-.092.84-.276.192-.184.288-.444.288-.78 0-.32-.096-.572-.288-.756-.184-.184-.464-.276-.84-.276h-1.272v2.088z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnershipRights);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMyIgeT0iMyIgd2lkdGg9IjE4IiBoZWlnaHQ9IjE4IiByeD0iMyIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNMTMuMjk2IDE2LjQyNEwxMS41NDQgMTMuMjQ0SDExLjA1MlYxNi40MjRIOVY4SDEyLjQ0NEMxMy4xMDggOCAxMy42NzIgOC4xMTYgMTQuMTM2IDguMzQ4QzE0LjYwOCA4LjU4IDE0Ljk2IDguOSAxNS4xOTIgOS4zMDhDMTUuNDI0IDkuNzA4IDE1LjU0IDEwLjE1NiAxNS41NCAxMC42NTJDMTUuNTQgMTEuMjEyIDE1LjM4IDExLjcxMiAxNS4wNiAxMi4xNTJDMTQuNzQ4IDEyLjU5MiAxNC4yODQgMTIuOTA0IDEzLjY2OCAxMy4wODhMMTUuNjEyIDE2LjQyNEgxMy4yOTZaTTExLjA1MiAxMS43OTJIMTIuMzI0QzEyLjcgMTEuNzkyIDEyLjk4IDExLjcgMTMuMTY0IDExLjUxNkMxMy4zNTYgMTEuMzMyIDEzLjQ1MiAxMS4wNzIgMTMuNDUyIDEwLjczNkMxMy40NTIgMTAuNDE2IDEzLjM1NiAxMC4xNjQgMTMuMTY0IDkuOThDMTIuOTggOS43OTYgMTIuNyA5LjcwNCAxMi4zMjQgOS43MDRIMTEuMDUyVjExLjc5MloiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };